import React, {Fragment, useEffect, useState} from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {Card, CardBody, Col, Row} from "reactstrap";
import UserTable from "Pages/Admin/Users/UsersTable";
import axiosInstance from "Api";
import PageHeading from "Layout/AppMain/PageHeading";


const Default = () => {
    const [data, setData] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    console.log('pageSize', pageSize);
    
    return (
        <Fragment>
            <PageHeading/>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                               timeout={1500} enter={false} exit={false}>
                    <div>
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <UserTable />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    )
};

export default Default;
